<ag-grid-angular
    class="report-grid h-full w-full"
    [autoSizeStrategy]="autoSizeStrategy"
    [columnDefs]="colDefs()"
    [rowData]="reportData()"

    [columnTypes]="columnTypes"
    [defaultColDef]="defaultColDef"
    [enableFilterHandlers]="true"
    [grandTotalRow]="grandTotalRow"
    [groupDefaultExpanded]="groupDefaultExpanded"
    [groupDisplayType]="groupDisplayType"
    [loading] = "isReportRunning()"
    [pivotMode]="layoutOptions()?.pivotMode"

    [rowSelection]="rowSelection"
    [sideBar]="sideBar"
    [theme]="theme()"
    [suppressAggFuncInHeader]="suppressAggFuncInHeader"
    (gridReady)="onGridReady($event)"
    (firstDataRendered)="onFirstDataRendered($event)"
    (filterChanged)="onFilterChanged($event)"
 />
